import { createAction } from '@reduxjs/toolkit';

const setCurrentUser = createAction('auth/setCurrentUser');

export default {
  setCurrentUser,
};
